import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PackagingLevelsDto } from '../core-data/packaging-levels-dto';
import { SectionTypeDto } from '../core-data/doc/section-type-dto';
import { EvidenceTypeDto } from '../core-data/doc/evidence-type-dto';
import { CheckboxFieldTypeDto } from '../core-data/doc/checkbox-field-type-dto';
import { environment } from 'src/environments/environment';
import { RadioGroupTypeDto } from '../core-data/doc/radio-group-type-dto';

@Injectable({ providedIn: 'root' })
export class CoreDataUpdateService {

  private _allPackagingLevels: PackagingLevelsDto[];
  private _allDOCSectionTypes: SectionTypeDto[];
  private _allDOCEvidenceTypes: EvidenceTypeDto[];
  private _allDOCCheckboxFieldTypes: CheckboxFieldTypeDto[];
  private _allDOCRadioGroupTypes: RadioGroupTypeDto[];
  private _allPackagingLevelsMap = new Map<string, PackagingLevelsDto>();
  private _allDOCEvidenceTypesMap = new Map<string, EvidenceTypeDto>();
  private _allDOCCheckboxFieldTypesMap = new Map<string, CheckboxFieldTypeDto>();
  private _allDOCSectionTypesMap = new Map<string, SectionTypeDto>();
  private _allDOCRadioGroupTypesMap = new Map<string, RadioGroupTypeDto>();


  constructor(
    private http: HttpClient,
  ) {
    this._allPackagingLevels = [];
    this._allDOCSectionTypes = [];
    this._allDOCEvidenceTypes = [];
    this._allDOCCheckboxFieldTypes = [];
    this._allDOCRadioGroupTypes = [];
  }

  get allPackagingLevels() : PackagingLevelsDto[] {
    return this._allPackagingLevels
  }

  get allDOCSectionTypes() : SectionTypeDto[] {
    return this._allDOCSectionTypes
  }

  get allDOCEvidenceTypes() : EvidenceTypeDto[] {
    return this._allDOCEvidenceTypes
  }

  get allDOCCheckboxFieldTypes() : CheckboxFieldTypeDto[] {
    return this._allDOCCheckboxFieldTypes
  }

  get allDOCRadioGroupTypes() : RadioGroupTypeDto[] {
    return this._allDOCRadioGroupTypes
  }

  get allPackagingLevelsMap() : Map<string, PackagingLevelsDto> {
    return this._allPackagingLevelsMap
  }

  get allDOCSectionTypesMap() :  Map<string, SectionTypeDto> {
    return this._allDOCSectionTypesMap
  }

  get allDOCEvidenceTypesMap() :  Map<string, EvidenceTypeDto> {
    return this._allDOCEvidenceTypesMap
  }

  get allDOCCheckboxFieldTypesMap() :  Map<string, CheckboxFieldTypeDto> {
    return this._allDOCCheckboxFieldTypesMap
  }

  get allDOCRadioGroupTypesMap() :  Map<string, RadioGroupTypeDto> {
    return this._allDOCRadioGroupTypesMap
  }

  public async updateCoreData() {
      this._allPackagingLevels = await this.getAllPackagingLevels();
      this._allDOCSectionTypes = await this.getAllDOCSectionTypes();
      this._allDOCEvidenceTypes = await this.getAllDOCEvidenceTypes();
      this._allDOCCheckboxFieldTypes = await this.getAllDOCCheckboxFieldTypes();
      this._allDOCRadioGroupTypes = await this.getAllDOCRadioGroupTypes();
      this._allPackagingLevelsMap.clear();
      this._allDOCSectionTypesMap.clear();
      this._allDOCEvidenceTypesMap.clear();
      this._allDOCCheckboxFieldTypesMap.clear();
      this._allDOCRadioGroupTypesMap.clear();

      for(const levels of this._allPackagingLevels) {
        if(!this._allPackagingLevelsMap.has(levels.id)) {
          this._allPackagingLevelsMap.set(levels.id,levels)
        }
      }
      for(const section of this._allDOCSectionTypes) {
        if(!this._allDOCSectionTypesMap.has(section.id)) {
          this._allDOCSectionTypesMap.set(section.id,section)
        }
      }
      for(const evidence of this._allDOCEvidenceTypes) {
        if(!this._allDOCEvidenceTypesMap.has(evidence.id)) {
          this._allDOCEvidenceTypesMap.set(evidence.id,evidence)
        }
      }
      for(const checkbox of this._allDOCCheckboxFieldTypes) {
        if(!this._allDOCCheckboxFieldTypesMap.has(checkbox.id)) {
          this._allDOCCheckboxFieldTypesMap.set(checkbox.id,checkbox)
        }
      }
      for(const radiogroup of this._allDOCRadioGroupTypes) {
        if(!this._allDOCRadioGroupTypesMap.has(radiogroup.id)) {
          this._allDOCRadioGroupTypesMap.set(radiogroup.id,radiogroup)
        }
      }
  }

  public async getAllDOCSectionTypes() : Promise<SectionTypeDto[]> {
    const url =  `${environment.webApiAddress}/api/doc/section-types`;
    return firstValueFrom(this.http.get<SectionTypeDto[]>(url));
  }

  public async getAllDOCEvidenceTypes() : Promise<EvidenceTypeDto[]> {
    const url =  `${environment.webApiAddress}/api/doc/evidence-types`;
    return firstValueFrom(this.http.get<EvidenceTypeDto[]>(url));
  }

   public async getAllDOCRadioGroupTypes() : Promise<RadioGroupTypeDto[]> {
    const url =  `${environment.webApiAddress}/api/doc/radiogroup-types`;
    return firstValueFrom(this.http.get<RadioGroupTypeDto[]>(url));
  }

  public async getAllDOCCheckboxFieldTypes() : Promise<CheckboxFieldTypeDto[]> {
    const url =  `${environment.webApiAddress}/api/doc/checkbox-types`;
    return firstValueFrom(this.http.get<CheckboxFieldTypeDto[]>(url));
  }

  public async getAllPackagingLevels() : Promise<PackagingLevelsDto[]> {
    const url =  `${environment.webApiAddress}/api/packaging-levels`;
    return firstValueFrom(this.http.get<PackagingLevelsDto[]>(url));
  }

}
